import type { CtaData } from "./schemas";

export default function Cta(props: CtaData) {
  return (
    <section className="relative w-full bg-background py-20 px-8 text-center">
      <div className="max-w-2xl mx-auto">
        {props.kicker && (
          <div className="text-[10px] tracking-[0.45em] uppercase text-gold/90 mb-5">
            {props.kicker}
          </div>
        )}
        {props.title && (
          <h2 className="font-serif text-3xl md:text-4xl leading-[1.1] text-foreground mb-4 max-w-[20ch] mx-auto">
            {props.title}
          </h2>
        )}
        {props.body && (
          <p className="text-sm md:text-base text-foreground/75 font-light leading-relaxed mb-8 max-w-[44ch] mx-auto">
            {props.body}
          </p>
        )}
        {props.button_label && props.button_url && (
          <a
            href={props.button_url}
            className="inline-block font-serif italic text-base text-background bg-gold/95 px-8 py-3.5 rounded-full tracking-wide hover:bg-gold transition"
          >
            {props.button_label}
          </a>
        )}
      </div>
    </section>
  );
}
